/**
 * @generated SignedSource<<ef2efb449c9bee74dc3c2a9dd0999f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserGeoInfo_user$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null> | null;
    readonly personalAddress: {
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null;
    readonly proAddress: {
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useUserGeoInfo_user";
};
export type useUserGeoInfo_user$key = {
  readonly " $data"?: useUserGeoInfo_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserGeoInfo_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserGeoInfo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "proAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8b165ca5f5bc5273b8bba53950bc2b19";

export default node;
